
import React from 'react';
import DataTablePagination from './DataTablePagination';

interface DataTableFooterProps {
  totalCount: number | null;  // Can be null for multi-source SKU reports where total is unknown
  filteredCount: number;
  isQueryResultsView?: boolean;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
  pageSize?: number;
}

const DataTableFooter: React.FC<DataTableFooterProps> = ({ 
  totalCount, 
  filteredCount,
  isQueryResultsView = false,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  pageSize = 100
}) => {
  if (filteredCount === 0) return null;

  // For multi-source aggregated reports, we don't know total count
  const showTotal = totalCount !== null && totalCount > 0;

  return (
    <div className="flex flex-col items-center" data-testid="data-table-footer">
      <div className="text-sm text-gray-500 mb-2">
        {isQueryResultsView 
          ? `Showing ${filteredCount} results from AI query`
          : showTotal
            ? `Showing page ${currentPage} of ${totalPages} (${filteredCount} of ${totalCount} entries)`
            : `Showing ${filteredCount} results${currentPage > 1 ? ` (page ${currentPage})` : ''}`}
      </div>
      
      {onPageChange && totalPages > 1 && (
        <DataTablePagination 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default DataTableFooter;
